import {
  CreditNote,
  CreditNoteSummary,
  handleValueWithNisCurrency,
  Invoice,
  InvoiceCredit,
  Payout,
  sum,
  SummaryItems,
} from '../..';
import { en } from '../theme/languages/en';
import { styles } from './SummaryData.module';

export const creditNoteSummaryValuesList = ({
  subTotal,
  taxPercentage,
  taxCalculatedValue,
  creditIsUsed,
  total,
  currentCreditsPaid,
  previousCreditsPaid,
  currency,
  hidePercentage,
  creditBalance,
  isPartialPeriod,
  isInvoiceShown,
}: CreditNoteSummary): SummaryItems[] => {
  return [
    {
      title: en.subTotal,
      value: handleValueWithNisCurrency(currency, subTotal),
      isVisible: true,
    },
    {
      title: hidePercentage ? en.tax : `${en.tax} (${taxPercentage}%)`,
      value: handleValueWithNisCurrency(currency, taxCalculatedValue),
      isVisible: !!taxPercentage || !!taxCalculatedValue,
    },
    {
      title: en.totalCredits,
      value: handleValueWithNisCurrency(currency, total),
      isVisible: true,
      containerStyle: styles.totalSumSection,
      labelStyle: [styles.boldText, { marginTop: 5 }],
      amountStyle: styles.boldText,
      isPartialPeriod: isPartialPeriod,
    },
    {
      title: en.previousCreditsPaid,
      value: `(${handleValueWithNisCurrency(currency, previousCreditsPaid)})`,
      isVisible: creditIsUsed && previousCreditsPaid > 0,
    },
    {
      title: en.currentCreditsPaid,
      value: `(${handleValueWithNisCurrency(currency, currentCreditsPaid)})`,
      isVisible: isInvoiceShown && currentCreditsPaid > 0,
    },
    {
      title: en.creditBalance,
      value: handleValueWithNisCurrency(currency, creditBalance),
      isVisible: creditIsUsed,
      labelStyle: [styles.boldText, styles.boldMediumText],
      amountStyle: [styles.boldText, styles.boldMediumText],
    },
  ];
};

export const getConnectedInvoiceLabel = (invoice?: Invoice) => {
  const poNumber = invoice?.poNumber ? `${en.with} ${invoice?.poNumber}` : '';
  return invoice ? `${en.relatedInvoice} ID-${invoice?.documentNumber} ${poNumber}` : '';
};

export const getPaidCredits = (invoiceCredit?: InvoiceCredit, creditNote?: CreditNote) => {
  if (invoiceCredit) {
    return invoiceCredit?.usedCredit;
  } else if (creditNote?.invoiceCredits?.length > 0) {
    return sum(creditNote?.invoiceCredits?.map((invoiceCredit) => invoiceCredit?.usedCredit));
  }
};

export const getCreditBalance = (total: number, invoiceCredit?: InvoiceCredit, CreditNoteData?: CreditNote) => {
  if (invoiceCredit) return invoiceCredit?.remainingCredit;
  else if (!!CreditNoteData?.invoiceCredits?.length) return CreditNoteData?.balance;
  return total;
};

export const getCreditNoteIdName = (creditNote: CreditNote | Payout) => {
  if (creditNote?.documentNumber) {
    return creditNote?.documentNumber;
  } else if (creditNote?.draftNumber) {
    return creditNote?.draftNumber;
  } else {
    return '';
  }
};
